// extracted by mini-css-extract-plugin
export var card = "_66-0";
export var content = "_66-1";
export var contentLoading = "_66-2";